import { render, staticRenderFns } from "./RecipeTile.vue?vue&type=template&id=305efc23&"
import script from "./RecipeTile.vue?vue&type=script&lang=ts&"
export * from "./RecipeTile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports